import { useNavigate } from "react-router-dom";

import { useRouterHook } from "@/shared/hooks";

interface LocationState {
    title: string;
}

export const useBreadcrumb = (): { setPageTitle: (title: string) => void } => {
    const { state, pathname, searchRaw } = useRouterHook<LocationState>();
    const { title: titleState } = state || {};
    const navigate = useNavigate();

    const setPageTitle = (title: string) => {
        setTimeout(() => {
            if (title && titleState !== title) {
                // Navigates to the current path, keeping the search parameters
                navigate(`${pathname}${searchRaw}`, {
                    state: {
                        ...state,
                        title,
                    },
                    replace: true,
                });
            }
        }, 0);
    };
    return {
        setPageTitle,
    };
};
